/**
 * Route for `custom-favicon-upload`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomFaviconUploadPage } from "../features/custom-favicon-upload/CustomFaviconUploadPage";

export const customFaviconUploadRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-favicon-upload",
	component: CustomFaviconUploadPage,
});

export default customFaviconUploadRoute;
